import { useListSeasonPassesQuery } from 'products/reduxApi'
import React, { useMemo } from 'react'
import { MultiSelectCombobox } from 'uiComponents/combobox'
import { FormItem, FormItemName } from 'uiComponents/form/formElements'
import './upgradeFrom.scss'

interface UpgradeFromProps {
    value: string[]
    onChange: (value: string[]) => void
}

export const UpgradeFrom = ({ value, onChange }: UpgradeFromProps) => {
    const { data: productOptionsData } = useListSeasonPassesQuery()
    const productOptions = useMemo(() => {
        return (
            productOptionsData?.map((product) => ({
                value: product.id.toString(),
                label: product.name,
            })) || []
        )
    }, [productOptionsData])

    return (
        <FormItem htmlFor="upgrade-from">
            <FormItemName>Products that can renew into this membership</FormItemName>
            <MultiSelectCombobox
                id="upgrade-from"
                value={value}
                onChange={onChange}
                options={productOptions}
                searchPlaceholder="Filter by product..."
                limitTags={10}
            />
            <div className="upgrade-from-explanation">
                <div>
                    Select any that apply. This allows users that own these products to renew into your membership.
                </div>
                <div>It also enables pre-populating personal details.</div>
            </div>
        </FormItem>
    )
}
